import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppContext } from "../utils/context/app-context";

import {
	Button,
	ContentContainer,
	TitleHeader,
	NarrowContentWrapper,
	AlertMessage,

	TableLoading
} from "../components/UiComponents";
import { CourseHeader, CourseWrapper } from "../components/CourseComponents";

import useDocumentTitle from "../components/useDocumentTitle";
import { Question } from "./HealthQuestionnairePage";


const WitnessIncidentPage = () => {
	useDocumentTitle("Witness Incident Report");
	const {
		dispatch,
		api,
	} = useAppContext();
	const { incidentId } = useParams();
	const [incident, setIncident] = useState(null);
	const [loading, setLoading] = useState(true);
	const [confirming, setConfirming] = useState(false);
	const [confirmed, setConfirmed] = useState(false);
	const [error, setError] = useState(null);
	let course = api.getCurrentCourse();

	useEffect(() => {
		fetchData();
	}, []);

	async function fetchData() {
		setError(null);
		const { data, error } = await api.fetchData(
			`/witness-incident/${incidentId}`
		);
		console.log(data);
		if (data?.data) {
			// dispatch({
			// 	type: "SET_STUDENT_HEALTH_QUESTIONNAIRE",
			// 	payload: {
			// 		form: data.form,
			// 		course_id: course.id,
			// 		date_id: state.current_date_id,
			// 		student_id: data.form.student_id,
			// 	},
			// });
			setIncident(data.data);
			setLoading(false);
		} else {
			setError(data?.error || error?.message || "Error fetching data")
			setLoading(false);
		}
	}

	async function handleConfirm(e) {
		e.preventDefault();
		setConfirming(true);
		setConfirmed(false);
		setError(null);

		const { data } = await api.fetchData(
			`/witness-incident/${incidentId}/confirm`,
			"POST"
		);

		console.log(data);
		if (data?.success) {
			setConfirming(false);
			setConfirmed(true);

			dispatch({
				type: "REMOVE_WITNESS_INCIDENT",
				payload: {
					incident_id: incidentId,
					course_id: course.id,
				},
			});
		} else {
			setError(data?.error || "An error occurred")
			setConfirming(false);
		}
	}

	function parseDate(date) {
		// Parse date from YYY-mm-dd to dd/mm/YYYY
		if (date !== "-") {
			let parts = date.split("-");
			return `${parts[2]}/${parts[1]}/${parts[0]}`;
		}
	}

	return (
		<div className="witness-incident-page">
			<CourseHeader />
			<ContentContainer classes="mb-4">
				<CourseWrapper>
					<TitleHeader title="Witness Incident Report" />
					<NarrowContentWrapper>
						{loading ? (
							<TableLoading rows={5} />
						) : (
							<div className="witness-incident-form">
								{confirmed && (
									<div className="physical-competency-page__submitted">
										<h3 className="physical-competency-page__submitted__title">
											Thank you
										</h3>
										<div className="physical-competency-page__submitted__message">
											<p>Your witness confirmation has been submitted.</p>
										</div>
									</div>
								)}
								{(incident && !confirmed) && (
									<div className="view-form">
										<Question
											label="Participant"
											answer={`${incident.name_of_person}`}
										/>
										<Question
											label="Date of Incident"
											answer={parseDate(incident.date_of_incident)}
										/>
										<Question
											label="Nature of Incident"
											answer={incident.answers?.nature_of_incident}
											multilineAnswer={true}
										/>
										<Question
											label="Incident Details"
											answer={incident.answers?.incident_details}
											multilineAnswer={true}
										/>
										<form action="" onSubmit={handleConfirm}>
											<Button
												type="tertiary"
												disabled={confirming}
												classes="btn-primary"
												buttonType="submit"
												text={confirming ? 'Confirming...' : 'Confirm Witnessing Incident'}
											/>
										</form>
									</div>
								)}
								{error && (
									<div className="mt-3">
										<AlertMessage type="danger" message={error} />
									</div>
								)}
							</div>
						)}
					</NarrowContentWrapper>
				</CourseWrapper>
			</ContentContainer>
		</div>
	)
};

export default WitnessIncidentPage;
